import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { createEntityAdapter } from '@reduxjs/toolkit'
import './Scripts.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import ComponentBox from '../../components/ComponentBox/ComponentBox'
import { useNavigate } from 'react-router-dom'
import ICSDataGrid from '../../components/ICSDataGrid/ICSDataGrid'
import {
  getAllScript,
  removeScript,
  getScript,
  setEntityError,
} from '../../redux/slices'
import { DefaultState } from '../../types'
import { Container, Col, Row, ModalBody } from 'reactstrap'
import HeaderBar from '../../components/HeaderBar/HeaderBar'
import ICSActionButton from '../../components/ICS/ActionButton/ICSActionButton'
import { ICSDataCellDetailView } from '../../components/ICSDataCellDetailView/ICSDataCellDetailView'
import ICSErrorCard from '../../components/ICSErrorCard/ICSErrorCard'
import { ICSModal } from '../../components/ICSModal/ICSModal'
import ScriptUpload from './ScriptUpload/ScriptUpload'
import { AppDispatch } from '../../services/lib'

const Scripts = () => {
  const navigate = useNavigate()
  const selectors = createEntityAdapter().getSelectors()
  const scriptsState = useSelector((state: DefaultState) => state.scripts)
  const scriptsError = useSelector((state: DefaultState) => state.scripts.error)
  const isAdmin: boolean | undefined = useSelector(
    (state: DefaultState) => state.session.data.user?.roles?.includes('admin')
  )
  const scriptsArray = selectors.selectAll(scriptsState)
  const [showUploadModal, setShowUploadModal] = useState<boolean>(false)
  const dispatch: AppDispatch = useDispatch()

  useEffect(() => {
    // prevents console error for invalid token
    if (window.location.pathname != '/ui2/login') {
      const initialData = async () => {
        await dispatch(getAllScript())
      }

      initialData()
    }
  }, [dispatch])

  function scriptAddButtonClicked() {
    if(!isAdmin) return;
    setShowUploadModal(true)
  }

  const hideModal = () => {
    dispatch(
      setEntityError({
        sliceName: 'scripts',
        entityName: 'Script',
        error: null,
      })
    )
    setShowUploadModal(false)
  }

  const calculateButtons = () => {
    if(isAdmin) {
      return [<ICSActionButton
        id='scriptUploadButton'
        type='success'
        width={65}
        height={35}
        stylingMode='contained'
        onClick={scriptAddButtonClicked}
        text='Add'
        disabled={!isAdmin}
      >
        <span className='glyphicons glyphicons-floppy-disk'></span>
        <span className='glyphicons glyphicons-plus'></span>
      </ICSActionButton>]
    } else {
      []
    }
  }

  return (
    <>
      <Container fluid={true}>
        <ICSModal
          visible={showUploadModal}
          onHiding={hideModal}
          title='Upload Script'
        >
          <ModalBody style={{padding:'0px'}}>
            <span>
              {showUploadModal && <ScriptUpload hideModal={hideModal} />}
            </span>
          </ModalBody>

        </ICSModal>
        <Row>
          <Col className='wivi-col'>
            <HeaderBar
              origin='IPA'
              routes={[
                {
                  title: 'Scripts',
                },
              ]}
              help={{
                title: 'Analysis Scripts',
                text: 'Analysis Scripts are the data processor assigned to an Analyzer. Users can see all Analyzer Scripts available to their organization. All users can upload Analyzer Scripts but it cannot be used by anyone until reviewed and approved by an administrator. AnalyzerScripts can be deleted by their owner and administrators. Scripts may be written in Python. R support may be added in the future.',
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={{ size: 12 }} className='wivi-col'>
            <ComponentBox>
              {scriptsError?.code === 'error' && !showUploadModal ? (
                <ICSErrorCard
                  code={scriptsError.code}
                  message={scriptsError.message}
                  fields={scriptsError.fields}
                />
              ) : (
                <ICSDataGrid
                  dataSource={scriptsArray}
                  columnOptions={[
                    {
                      type: 'buttons',
                      caption: 'Action',
                      width: 110,
                      buttons: [
                        {
                          hint: 'Configurations',
                          icon: 'preferences',
                          onClick: function review(e) {
                            dispatch(getScript(e.row.data.id))
                            navigate(`/ui2/scripts/${e.row.data.id}/configurations`)
                          },
                        },
                        {
                          hint: 'Delete',
                          icon: 'trash',
                          onClick: async function review(e) {
                            const r = window.confirm(
                              `Are you sure you want to delete the following Script: ${e.row.data.name}?`
                            )
                            if (r === true) {
                              await dispatch(removeScript(e.row.data.id))
                              await dispatch(getAllScript())
                            }
                          },
                        },
                      ].filter(button => isAdmin || button.hint !== 'Delete')
                    },
                    { dataField: 'name', caption: 'Name' },
                    {
                      dataField: 'description',
                      caption: 'Description',
                      cellRender: data => {
                        return (
                          <ICSDataCellDetailView
                            {...data}
                            modalWidth='35vw'
                            modalHeight='20vh'
                          />
                        )
                      },
                    },
                    { dataField: 'user.name', caption: 'User' },
                    { dataField: 'created_at', caption: 'Create Date' },
                  ]}
                  options={{
                    buttons: calculateButtons(),
                  }}
                />
              )}
            </ComponentBox>
          </Col>
        </Row>
      </Container>
    </>
  )
}
export default Scripts
